var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_3538",
    x: 0,
    y: 0,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51385",
    "data-name": "Group 51385",
    transform: "translate(-252 -203.662)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 252, 203.66)",
    filter: "url(#Ellipse_3538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3538-2",
    "data-name": "Ellipse 3538",
    transform: "translate(9 7)",
    fill: "#fff",
    stroke: "#325d88",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51228",
    "data-name": "Group 51228",
    transform: "translate(-1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5949",
    "data-name": "Line 5949",
    x1: 7,
    y2: 7,
    transform: "translate(269 216.662)",
    fill: "none",
    stroke: "#325d88",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5987",
    "data-name": "Line 5987",
    x1: 7,
    y1: 7,
    transform: "translate(269 216.662)",
    fill: "none",
    stroke: "#325d88",
    strokeLinecap: "round",
    strokeWidth: 1.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIncomplete);
export default __webpack_public_path__ + "static/media/report-incomplete.828b2b663e3edd353c2b65dd9da2a148.svg";
export { ForwardRef as ReactComponent };